<template>
  <form-wrapper
    :target="getId"
    :inline="inline"
    :icon="icon"
    :icon-classes="iconClasses"
    :underlined="underlined"
    :label-classes="labelClasses"
    :label="label"
    :error="error"
    :required="required"
    @keyup.native.esc="close"
    v-click-outside.native="close">
    <input
      class="form-field"
      type="date"
      :class="[fieldClasses, getFieldClasses]"
      :placeholder="placeholder"
      :id="getId"
      :name="name"
      :disabled="disabled"
      :required="required"
      :readonly="readonly"
      v-model="inputDate"
      @focus="open"
    />
    <transition name="scale">
      <DatePicker
        v-show="isOpen && !isMobile()"
        class="absolute width-full bg-white shadow-xl p-4 text-center z-10 duration-150"
        :start-date="inputDate"
        :class="getPosition"
        @change="onChange"
        :format="format"
        :tabbable="isOpen"
        :disable-weekends="disableWeekends"
        :disable-passed-dates="disablePassedDates"
        :enable-limit="enableLimit"
        :limit="limit"
      />
    </transition>
    <template #label><slot name="label"></slot></template>
    <template #icon><slot name="icon"></slot></template>
  </form-wrapper>
</template>

<script>
import ClickOutside from "vue-click-outside";
import moment from "moment";
import { isMobile } from "../../helpers/utils";
import DatePicker from "../DatePicker";
import FormWrapper from "./FormWrapper";

export default {
  components: {
    DatePicker,
    FormWrapper
  },
  model: {
    event: "change"
  },
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    value: String,
    label: String,
    name: String,
    icon: String,
    fieldClasses: [String, Array],
    labelClasses: [String, Array],
    iconClasses: [String, Array],
    placeholder: {
      type: String,
      default: "01/01/2020"
    },
    error: [String, Array],
    underlined: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "bottom left"
    },
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    limit: String,
    enableLimit: Boolean,
    disablePassedDates: Boolean,
    disableWeekends: Boolean,
  },
  directives: {
    ClickOutside
  },
  computed: {
    getPosition() {
      return {
        "left-0": this.position.includes("left"),
        "right-0": this.position.includes("right"),
        "top-100": this.position.includes("bottom"),
        "bottom-100": this.position.includes("top")
      };
    },
    getFieldClasses() {
      return {
        "is-underlined": this.underlined,
        "border-danger focus:border-danger": this.error,
        "has-icon": this.icon
      };
    },
    getId() {
      return this.name ? `${this.name}-${this._uid}` : this._uid;
    },
    inputDate: {
      get() {
        return this.value ? moment(this.value).format(this.format) : "";
      },
      set(value) {
        if (moment(value).isValid()) {
          this.$emit("change", moment(value).format(this.format));
        }
      }
    }
  },
  methods: {
    onChange(event) {
      this.$emit("change", event);
      this.close();
    },
    getDayTabIndex(day) {
      return this.isOpen && !this.isDisabled(day) ? 0 : -1;
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    isMobile
  }
};
</script>

<style scoped>
.scale-enter, .scale-leave-to {
  @apply transform scale-95 opacity-0;
}
input::-webkit-inner-spin-button,
input::-webkit-calendar-picker-indicator,
input::-webkit-clear-button {
  display: none;
  -webkit-appearance: none;
}
</style>


